import React, { useContext, useEffect, useMemo, useState } from 'react';

import { Select, Tooltip } from 'antd';
import { QuestionCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useGetModulesQuery } from 'src/redux/services/centralApi';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import type {
	IModuleSelectComponent
} from 'src/pages/observers/components/ModuleSelect/types';
import { ModuleAssignArea } from 'src/pages/observers/components/ModuleSelect/styles';
import { AuthContext } from 'src/AuthProvider';
import { checkRole } from 'src/common/helpers/checkRole';

export default function ModuleSelect(
	{
		defaultModule,
		onModuleChange,
	}: IModuleSelectComponent
) {
	const { user, } = useContext(AuthContext);
	
	const {
		data: modulesData,
		isLoading: isLoadingModulesData,
	} = useGetModulesQuery({});

	const [ selectedModule, setSelectedModule, ] = useState<string | null>(defaultModule);

	const modulesOptions = useMemo(() => {
		if (!modulesData) return [];

		const isSuperAdmin = checkRole('super_admin', { user, });
		
		return modulesData.flatMap(module => {
			if(!module.is_active) return [];
			if(isSuperAdmin || module.partner_id)
				return {
					label: module.name,
					value: module.module_id,
				};

			return [];
		});
	}, [ modulesData, ]);

	useEffect(() => {
		if (!selectedModule) return;
		onModuleChange && onModuleChange(selectedModule);
	}, [ selectedModule, ]);

	if(modulesOptions.length === 0) return <></>;

	return (
		<ModuleAssignArea gap={16}>
			<WarningOutlined
				style={{
					color: 'red',
					fontSize: '24px',
				}}
			/>
			<FormItem style={{ width: '100%', }}>
				<FormLabel>
					Atribuir módulo:
					<Tooltip
						title={'Atribua um módulo ao observador para inserí-lo na store.'}
					>
						<QuestionCircleOutlined
							style={{
								color: 'rgba(0,0,0,0.45)',
								cursor: 'help',
							}}
						/>
					</Tooltip>
				</FormLabel>
				<Select
					allowClear
					placeholder='Módulo'
					value={selectedModule}
					onChange={(value) => setSelectedModule(value)}
					options={modulesOptions}
					loading={isLoadingModulesData}
					disabled={modulesOptions.length === 0}
				/>
			</FormItem>
		</ModuleAssignArea>
	);
}
